module.exports = __webpack_public_path__ + "static/media/bg.083cedf1.png";